

exports.__esModule = true;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('components/xo-models/src/checkout/index');

var _index2 = require('components/xo-models/src/user/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionDirective', {
    tag: 'xo-currency-conversion',
    template: _template2['default'],

    props: {
        token: {
            type: 'var'
        },
        doneFn: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        changeConversionChoice: function changeConversionChoice() {
            // The button will usually be Agree but for Brazil, when Vendor is chosen,
            // the button changes to Continue.
            this.continueButton = _squid.$locale.content.get('buttons.agree');

            if (this.conversion.from_code === 'BRL' && !this.models.ppconversion) {
                this.continueButton = _squid.$locale.content.get('buttons.continue');
            }
        },
        onSubmit: function onSubmit() {
            var _this = this;

            if (this.models.ppconversion === this.conversion.paypal) {
                this.props.doneFn();
                return;
            }

            var conversionType = this.models.ppconversion ? 'PAYPAL' : 'VENDOR';
            var payload = {
                conversionType: conversionType,
                planId: this.checkoutInputData.funding_option_id || this.models.checkoutSession.plan.id
            };

            if (payload.planId) {
                this.models.checkoutSession.fundingOptions.action('updateConversion', {

                    data: payload,

                    success: function success(result) {
                        _this.models.checkoutSession.reload({
                            success: function success() {
                                var conversion = _this.models.checkoutSession.plan.conversion || {};
                                if (!_this.models.ppconversion) {
                                    if (conversion.paypal) {
                                        _logger.$logger.info('currency_conversion_not_honored', {
                                            type: _this.currencyConverion,
                                            from: conversion.from,
                                            to: conversion.to,
                                            changeable: conversion.changeable
                                        });
                                    } else {
                                        _this.models.checkoutSession.plan.conversion = {
                                            changeable: true,
                                            paypal: false
                                        };
                                    }
                                }
                            }
                        });

                        _this.props.doneFn(result);
                    }
                });
            }
        }
    },

    lifecycle: {
        populate: function populate() {
            this.conversion = this.models.checkoutSession.plan.conversion;
            this.models.ppconversion = this.conversion.paypal;
            this.continueButton = _squid.$locale.content.get('buttons.agree');
            this.checkoutInputData = _index2.$CheckoutInputDataModel.instance(this.props.token);

            var fundingOptionId = this.checkoutInputData.funding_option_id;
            if (fundingOptionId && fundingOptionId !== this.models.checkoutSession.plan.id) {
                this.models.checkoutSession.fundingOptions.action('getConversion', {

                    data: {
                        planId: fundingOptionId
                    },

                    success: function success(result) {
                        this.conversion = result;
                    }
                });
            }
        }
    }
});


_squid.$Component;

_squid.$locale;

_logger.$logger;

_index.$CheckoutSessionModel;

_index2.$CheckoutInputDataModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/currency-conversion/directive.js
// module id = ./components/xo-wallet-components/src/currency-conversion/directive.js
// module chunks = 1